const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Personalized Please: additional product-card hover videos. Draft theme only. */
(() => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const hoverVideos = {
    'custom-round-leatherette-coasters-with-company-logo': 'https://cdn.shopify.com/videos/c/vp/71b2220a0e86441f89e3a26eacd26af3/71b2220a0e86441f89e3a26eacd26af3.HD-720p-1.6Mbps-96013153.mp4',
    'custom-logo-30-oz-tumblers-single-bulk-packs': 'https://cdn.shopify.com/videos/c/vp/acecb1c7b3c1470a8272cf338a48dcfa/acecb1c7b3c1470a8272cf338a48dcfa.HD-720p-1.6Mbps-95232614.mp4',
    'custom-leatherette-can-coolers-with-company-logo': 'https://cdn.shopify.com/videos/c/vp/1e355f2de12d474b98594eadb0ddef10/1e355f2de12d474b98594eadb0ddef10.HD-720p-1.6Mbps-93931163.mp4',
    'custom-16-oz-pint-glasses-with-company-logo': 'https://cdn.shopify.com/videos/c/vp/799dc3ef7d3e4fc1a7a7b7d4146f98db/799dc3ef7d3e4fc1a7a7b7d4146f98db.HD-720p-1.6Mbps-93932013.mp4',
    '20-oz-gold-tumbler-with-company-logo': 'https://cdn.shopify.com/videos/c/vp/fb2f05c12cb744d7aab562a4a2760882/fb2f05c12cb744d7aab562a4a2760882.HD-720p-1.6Mbps-93935130.mp4',
    'custom-square-slate-coasters-with-company-logo': 'https://cdn.shopify.com/videos/c/vp/8a4fd1f962c14ae789270c45ce7d14f9/8a4fd1f962c14ae789270c45ce7d14f9.HD-720p-2.1Mbps-93936309.mp4',
    'custom-round-slate-coasters-with-company-logo': 'https://cdn.shopify.com/videos/c/vp/03e3d89fa209412f9e68f47adf115e8d/03e3d89fa209412f9e68f47adf115e8d.HD-720p-1.6Mbps-93936608.mp4',
    'custom-bottle-opener-with-company-logo': 'https://cdn.shopify.com/videos/c/vp/cc5ab94b7c6a4bd69c44071c933f6c66/cc5ab94b7c6a4bd69c44071c933f6c66.HD-720p-1.6Mbps-93938117.mp4',
    'custom-15-oz-stemless-wine-glasses-with-company-logo': 'https://cdn.shopify.com/videos/c/vp/2eff1175f7fc420ca45be9aa733125f7/2eff1175f7fc420ca45be9aa733125f7.HD-720p-1.6Mbps-93945583.mp4',
    'custom-12-oz-wine-tumbler-with-company-logo-1': 'https://cdn.shopify.com/videos/c/vp/d745fb1a28d84f61a377a6b7da84d6ab/d745fb1a28d84f61a377a6b7da84d6ab.HD-720p-1.6Mbps-94758499.mp4'
  };

  function enhanceCards(root = document) {
    root.querySelectorAll('.product-card-wrapper').forEach((card) => {
      if (card.dataset.ppExtraHoverReady === 'true' || card.dataset.ppHoverVideoReady === 'true') return;
      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      let handle = '';
      try {
        const pathname = new URL(link.href, window.location.origin).pathname;
        const match = pathname.match(/\/products\/([^/?#]+)/);
        handle = match ? match[1] : '';
      } catch { return; }
      const videoUrl = hoverVideos[handle];
      if (!videoUrl) return;
      const media = card.querySelector('.media.media--hover-effect');
      if (!media) return;
      const video = document.createElement('video');
      video.className = 'pp-product-hover-video';
      video.src = videoUrl;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.preload = 'auto';
      video.setAttribute('aria-hidden', 'true');
      video.setAttribute('tabindex', '-1');
      media.appendChild(video);
      card.classList.add('pp-has-hover-video');
      card.dataset.ppExtraHoverReady = 'true';
      card.addEventListener('mouseenter', () => {
        const p = video.play();
        if (p?.catch) p.catch(() => {});
      });
      card.addEventListener('mouseleave', () => {
        video.pause();
        try { video.currentTime = 0; } catch {}
      });
    });
  }

  function initHoverVideos() {
    enhanceCards();
    const observer = new MutationObserver(() => enhanceCards());
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverVideos, { once: true });
  } else {
    initHoverVideos();
  }
})();
